import React from 'react';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import { styled } from '@mui/material/styles';

const BottomLogoImage = styled('img')(({ theme }) => ({
    width: '100%',
    objectFit: 'cover',
    position: 'relative',
}));

const GradientOverlay = styled('div')(({ theme }) => ({
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: `linear-gradient(to bottom, rgba(0,0,0,0.92) 0%, rgba(0,0,0,0.95) 50%, rgba(0,0,0,1) 98%)`,
    pointerEvents: 'none',
}));

export default function BottomLogo() {
    return (
        <Box
            id="bottom-logo"
            sx={{
                width: '100%',
                backgroundRepeat: 'no-repeat',
                background: 'black',
                position: 'relative',
                overflow: 'hidden',
            }}
        >
            <Container
                sx={(theme) => ({
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '160px',
                    flexDirection: 'column',
                    position: 'relative',
                    overflow: 'hidden',
                    marginTop: 6,
                    [theme.breakpoints.down('sm')]: {
                        height: '100px',
                    }
                })}
            >
                <BottomLogoImage src={'/images/footer.webp'} alt="Footer Logo" />
                <GradientOverlay />
            </Container>
        </Box>
    );
}